var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_172)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.6702 0 0 15.6702 0 35C0 51.4136 11.3008 65.1868 26.5454 68.9696V45.696H19.3284V35H26.5454V30.3912C26.5454 18.4786 31.9368 12.957 43.6324 12.957C45.85 12.957 49.6762 13.3924 51.2414 13.8264V23.5214C50.4154 23.4346 48.9804 23.3912 47.1982 23.3912C41.4596 23.3912 39.242 25.5654 39.242 31.2172V35H50.6744L48.7102 45.696H39.242V69.7438C56.5726 67.6508 70.0014 52.8948 70.0014 35C70 15.6702 54.3298 0 35 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5014 35C69.5014 52.4456 56.553 66.8653 39.742 69.1751V46.196H48.7102H49.1267L49.202 45.7863L51.1662 35.0903L51.2746 34.5H50.6744H39.742V31.2172C39.742 28.438 40.2907 26.65 41.4186 25.5414C42.5487 24.4305 44.372 23.8912 47.1982 23.8912C48.9795 23.8912 50.3915 23.9348 51.1891 24.0187L51.7414 24.0767V23.5214V13.8264V13.4462L51.375 13.3446C49.7534 12.8949 45.8794 12.457 43.6324 12.457C37.7149 12.457 33.2869 13.8535 30.3458 16.8571C27.4068 19.8584 26.0454 24.3702 26.0454 30.3912V34.5H19.3284H18.8284V35V45.696V46.196H19.3284H26.0454V68.3242C11.3333 64.38 0.5 50.9549 0.5 35C0.5 15.9463 15.9463 0.5 35 0.5C54.0536 0.5 69.5 15.9463 69.5014 35Z",
    stroke: "#CB37FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_172",
    x: -18.9,
    y: -18.9,
    width: 107.801,
    height: 107.544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_172",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.52e175ef278f4b880121be0dfe2a9131.svg";
export { ForwardRef as ReactComponent };